import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const OsUpdateGlyph = /*#__PURE__*/createElement("g", {
  id: "os_update"
}, /*#__PURE__*/createElement("path", {
  d: "M78.8 44.3c-.4-.8-1.3-1.4-2.3-1.4h-8.1C67.2 25.5 57.7 15.5 42 15.5c-.7 0-1.3.5-1.4 1.2-.2.7.2 1.4.8 1.7.24.12 4.13 1.94 7.34 7.49h3.43c-1.58-3.16-3.42-5.43-5.07-6.99 15.1 2.6 18 16.8 18.4 25.6.1.8.7 1.4 1.5 1.4h8.9L61.2 65.4l-5.08-6.74h-3.75L59 67.5c.5.6 1.3 1 2.1 1 .9 0 1.6-.4 2.1-1L78.5 47c.6-.8.7-1.9.3-2.7zM42.6 65.7c-.23-.12-3.91-1.85-7.07-7.04h-3.41c1.51 2.87 3.23 4.97 4.78 6.44-15.1-2.6-18-16.8-18.4-25.6-.1-.8-.7-1.4-1.5-1.4H8.2l14.7-19.4 5.45 7.19h3.62L25 16.6c-.5-.6-1.3-1-2.1-1s-1.6.3-2.1 1L5.5 37c-.6.8-.7 1.8-.3 2.7.4.8 1.3 1.4 2.3 1.4h8.1C16.8 58.5 26.3 68.5 42 68.5c.7 0 1.3-.5 1.4-1.1.2-.7-.2-1.4-.8-1.7z"
}), /*#__PURE__*/createElement("path", {
  d: "M35.12 49.92c-4.97 0-8.09-3.8-8.09-8.92 0-5.36 3.41-9.18 8.35-9.18 5.1 0 8.11 3.87 8.11 8.87 0 5.88-3.56 9.23-8.35 9.23h-.02zm.16-2.58c3.09 0 4.84-2.86 4.84-6.53 0-3.3-1.64-6.42-4.84-6.42s-4.86 3.04-4.86 6.53 1.77 6.42 4.84 6.42h.02zM46.2 46.15c1.01.6 2.6 1.12 4.24 1.12 2.03 0 3.17-.96 3.17-2.39 0-1.33-.88-2.11-3.09-2.91-2.91-1.01-4.76-2.57-4.76-5.07 0-2.89 2.39-5.04 6.21-5.04 1.9 0 3.28.42 4.19.86l-.75 2.6c-.65-.34-1.87-.83-3.51-.83-2.03 0-2.89 1.07-2.89 2.11 0 1.35 1.01 1.98 3.35 2.86 3.04 1.17 4.5 2.7 4.5 5.2 0 2.83-2.13 5.25-6.63 5.25-1.87 0-3.8-.52-4.76-1.09l.73-2.67z"
}));
const OsUpdate = createSvg({
  name: 'os_update',
  path: OsUpdateGlyph
});

export default OsUpdate;
export { OsUpdateGlyph };
